__turbopack_context__.v({
  "dragContainer": "split-content-module__Rc3aFG__dragContainer",
  "dragHandle": "split-content-module__Rc3aFG__dragHandle",
  "dragHandleAnimated": "split-content-module__Rc3aFG__dragHandleAnimated",
  "dragHandleColumn": "split-content-module__Rc3aFG__dragHandleColumn",
  "dragHandleColumnReverse": "split-content-module__Rc3aFG__dragHandleColumnReverse",
  "dragHandleRow": "split-content-module__Rc3aFG__dragHandleRow",
  "dragHandleRowReverse": "split-content-module__Rc3aFG__dragHandleRowReverse",
  "foregroundInner": "split-content-module__Rc3aFG__foregroundInner",
  "layoutContainer": "split-content-module__Rc3aFG__layoutContainer",
  "splitContentBackground": "split-content-module__Rc3aFG__splitContentBackground",
  "splitContentBackgroundAdaptive": "split-content-module__Rc3aFG__splitContentBackgroundAdaptive",
  "splitContentBackgroundAnimated": "split-content-module__Rc3aFG__splitContentBackgroundAnimated",
  "splitContentBackgroundColumn": "split-content-module__Rc3aFG__splitContentBackgroundColumn",
  "splitContentBackgroundColumnReverse": "split-content-module__Rc3aFG__splitContentBackgroundColumnReverse",
  "splitContentBackgroundFull": "split-content-module__Rc3aFG__splitContentBackgroundFull",
  "splitContentBackgroundRow": "split-content-module__Rc3aFG__splitContentBackgroundRow",
  "splitContentBackgroundRowReverse": "split-content-module__Rc3aFG__splitContentBackgroundRowReverse",
  "splitContentContent": "split-content-module__Rc3aFG__splitContentContent",
  "splitContentContentAnimated": "split-content-module__Rc3aFG__splitContentContentAnimated",
  "splitContentContentColumn": "split-content-module__Rc3aFG__splitContentContentColumn",
  "splitContentContentColumnReverse": "split-content-module__Rc3aFG__splitContentContentColumnReverse",
  "splitContentContentRow": "split-content-module__Rc3aFG__splitContentContentRow",
  "splitContentContentRowReverse": "split-content-module__Rc3aFG__splitContentContentRowReverse",
});
